import { API } from '../api';
import { VM } from '../model';

const invalidAddress: string = 'invalid-address';

export const mapUserAssistanceIPFromApiToVM = (userAssistanceIP: API.UserAssistanceIP): VM.UserAssistanceIP => ({
    ip: userAssistanceIP.ip ?? invalidAddress,
});
